(function (window, document) {
  'use strict';

  var BUTTON_SELECTOR = 'a[href], button, [role="button"], .btn';
  var SLIDER_SELECTOR = 'slideshow-component, slideshow-with-product, images-text, collection-list-slider';
  var BANNER_SLIDE_SELECTOR = '.swiper-slide';
  var SECTION_SELECTOR = '[id^="shopify-section-"]';
  var SECTION_VIEW_THRESHOLD = 0.35;
  var SWIPE_DISTANCE = 40;
  var SWIPE_AXIS_RATIO = 1.5;
  var pointerStart = null;

  function isHomePage() {
    var pageType = window.ColamyPage && window.ColamyPage.type;
    var bodyClass = document.body && document.body.className;

    return pageType === 'index' || (typeof bodyClass === 'string' && bodyClass.indexOf('index-template') !== -1);
  }

  function analytics() {
    return window.ColamyAnalytics && typeof window.ColamyAnalytics.track === 'function'
      ? window.ColamyAnalytics
      : null;
  }

  function sectionFromElement(element) {
    if (!element || typeof element.closest !== 'function') return null;
    return element.closest(SECTION_SELECTOR);
  }

  function getSectionId(element) {
    var section = sectionFromElement(element);
    return section ? section.id : '';
  }

  function getSectionType(element) {
    var section = sectionFromElement(element);
    if (!section) return '';

    var type = section.getAttribute && section.getAttribute('data-section-type');
    if (type) return type;

    return section.id ? section.id.replace(/^shopify-section-/, '').split('_')[0] : '';
  }

  function getSectionHandle(element) {
    var section = sectionFromElement(element);
    if (!section) return '';

    var type = section.getAttribute && section.getAttribute('data-section-type');
    if (type) return type.replace(/-/g, '_');

    var id = section.id ? section.id.replace(/^shopify-section-/, '') : '';
    var parts = id.split('_');
    if (parts.length <= 1) return id;

    parts.pop();
    return parts.join('_');
  }

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim().slice(0, 120);
  }

  function blockFromElement(element) {
    if (!element || typeof element.closest !== 'function') return null;
    return element.closest('[data-block-id]');
  }

  function getBlockId(element) {
    var block = blockFromElement(element);
    return block && block.dataset ? block.dataset.blockId || '' : '';
  }

  function elementPosition(element, selector) {
    var section = sectionFromElement(element);
    if (!section || typeof section.querySelectorAll !== 'function') return null;

    var elements = Array.prototype.slice.call(section.querySelectorAll(selector));
    var index = elements.indexOf(element);
    return index >= 0 ? index + 1 : null;
  }

  function isBannerSection(element) {
    var section = sectionFromElement(element);
    if (!section) return false;

    var type = section.getAttribute && section.getAttribute('data-section-type');
    var id = section.id || '';

    return type === 'slideshow-banner'
      || id.indexOf('slideshow_banner') !== -1
      || id.indexOf('slideshow-banner') !== -1;
  }

  function findBannerSlide(target) {
    if (!target || typeof target.closest !== 'function') return null;

    var slide = target.closest(BANNER_SLIDE_SELECTOR);
    return slide && isBannerSection(slide) ? slide : null;
  }

  function activeBannerSlide(slider) {
    if (!slider || !isBannerSection(slider) || typeof slider.querySelector !== 'function') return null;

    return slider.querySelector('.swiper-slide-active')
      || slider.querySelector('[aria-hidden="false"]')
      || slider.querySelector(BANNER_SLIDE_SELECTOR);
  }

  function getBannerIndex(slide) {
    if (!slide) return null;

    var datasetIndex = slide.dataset && slide.dataset.index;
    if (datasetIndex !== undefined && datasetIndex !== null && datasetIndex !== '') {
      var parsedIndex = parseInt(datasetIndex, 10);
      return isNaN(parsedIndex) ? null : parsedIndex + 1;
    }

    return elementPosition(slide, BANNER_SLIDE_SELECTOR);
  }

  function bannerProperties(slide) {
    return {
      section_id: getSectionId(slide),
      section_type: getSectionType(slide),
      banner_id: slide && slide.dataset ? slide.dataset.blockId || '' : '',
      banner_index: getBannerIndex(slide),
      banner_type: slide && slide.dataset ? slide.dataset.type || '' : '',
      banner_text: cleanText(slide && slide.textContent),
    };
  }

  function trackBannerView(slide) {
    if (!slide || !slide.dataset) return;

    var bannerKey = slide.dataset.blockId || getSectionId(slide) + ':' + getBannerIndex(slide);
    if (slide.dataset.colamyAnalyticsBannerViewed === bannerKey) return;

    slide.dataset.colamyAnalyticsBannerViewed = bannerKey;
    track('home_banner_view', bannerProperties(slide));
  }

  function trackActiveBannerView(slider) {
    trackBannerView(activeBannerSlide(slider));
  }

  function track(eventName, properties) {
    var client = analytics();
    if (!client) return;

    client.track(eventAction(eventName), Object.assign(
      { event_detail: eventName },
      properties || {}
    ));
  }

  function eventAction(eventName) {
    if (/_view$/.test(eventName)) return 'view';
    if (/_click$/.test(eventName)) return 'click';
    if (/_swipe$/.test(eventName)) return 'swipe';
    if (/_change$/.test(eventName)) return 'change';
    return eventName;
  }

  function findButton(target) {
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest(BUTTON_SELECTOR);
  }

  function moduleClickEventName(element) {
    var sectionHandle = getSectionHandle(element);

    if (sectionHandle === 'images_text') return 'home_image_card_click';
    if (sectionHandle === 'promotion_banner') return 'home_promotion_banner_click';
    if (sectionHandle === 'featured_collection') return 'home_featured_collection_click';
    if (sectionHandle === 'slideshow_with_product_bottom') return 'home_slider_product_click';
    if (sectionHandle === 'lookbook_banner') return 'home_lookbook_click';
    if (sectionHandle === 'testimonials_masonry') return 'home_testimonial_product_click';
    if (sectionHandle === 'scrolling_promotion') return 'home_scrolling_promotion_click';
    if (sectionHandle === 'custom_content') return 'home_custom_content_click';
    if (sectionHandle === 'video_hero_icons') return 'home_video_hero_icon_click';
    if (sectionHandle === 'scrolling_gallery_image') return 'home_scrolling_gallery_click';
    if (sectionHandle === 'featured_blog') return 'home_featured_blog_click';
    return 'home_button_click';
  }

  function handleButtonClick(event) {
    var button = findButton(event && event.target);
    if (!button) return;
    var bannerSlide = findBannerSlide(button);
    var clickName = cleanText(button.textContent);
    var clickProperties = {
      section_id: getSectionId(button),
      section_type: getSectionType(button),
      section_handle: getSectionHandle(button),
      block_id: getBlockId(button),
      click_name: clickName,
      button_text: clickName,
      href: button.href || button.getAttribute && button.getAttribute('href') || '',
      button_type: button.tagName ? button.tagName.toLowerCase() : '',
      position: elementPosition(button, BUTTON_SELECTOR),
    };

    track(moduleClickEventName(button), clickProperties);

    if (bannerSlide) {
      track('home_banner_click', Object.assign(
        bannerProperties(bannerSlide),
        clickProperties
      ));
    }
  }

  function findSlider(target) {
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest(SLIDER_SELECTOR);
  }

  function handlePointerDown(event) {
    var slider = findSlider(event && event.target);
    if (!slider) return;

    pointerStart = {
      target: slider,
      x: event.clientX,
      y: event.clientY,
    };
  }

  function handlePointerUp(event) {
    if (!pointerStart) return;

    var slider = findSlider(event && event.target) || pointerStart.target;
    if (!slider || slider !== pointerStart.target) {
      pointerStart = null;
      return;
    }

    var deltaX = event.clientX - pointerStart.x;
    var deltaY = event.clientY - pointerStart.y;
    var absX = Math.abs(deltaX);
    var absY = Math.abs(deltaY);

    pointerStart = null;

    if (absX < SWIPE_DISTANCE || absX < absY * SWIPE_AXIS_RATIO) return;

    track('home_slider_swipe', {
      section_id: getSectionId(slider),
      section_type: getSectionType(slider),
      slider_type: slider.tagName ? slider.tagName.toLowerCase() : '',
      direction: deltaX < 0 ? 'next' : 'previous',
    });
  }

  function handleSliderControlClick(event) {
    var target = event && event.target;
    if (!target || typeof target.closest !== 'function') return;

    var control = target.closest('.swiper-button, .swiper-pagination-bullet');
    if (!control) return;

    var slider = findSlider(control);
    if (!slider) return;

    track('home_slider_control_click', {
      section_id: getSectionId(slider),
      section_type: getSectionType(slider),
      slider_type: slider.tagName ? slider.tagName.toLowerCase() : '',
      control_type: control.className && control.className.indexOf('swiper-button-next') !== -1
        ? 'next'
        : control.className && control.className.indexOf('swiper-button-prev') !== -1
          ? 'previous'
          : 'pagination',
    });
  }

  function observeSliderChanges() {
    var sliders = document.querySelectorAll ? document.querySelectorAll(SLIDER_SELECTOR) : [];
    if (!sliders || !sliders.length) return;
    var MutationObserverConstructor = window.MutationObserver || window.WebKitMutationObserver;

    Array.prototype.forEach.call(sliders, function (slider) {
      if (!slider || slider.dataset.colamyAnalyticsObserved === 'true') return;

      slider.dataset.colamyAnalyticsObserved = 'true';
      trackActiveBannerView(slider);

      if (typeof MutationObserverConstructor !== 'function') return;

      var observer = new MutationObserverConstructor(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName !== 'selected-index') return;

          track('home_slider_change', {
            section_id: getSectionId(slider),
            section_type: getSectionType(slider),
            slider_type: slider.tagName ? slider.tagName.toLowerCase() : '',
            selected_index: slider.getAttribute('selected-index') || '',
          });

          trackActiveBannerView(slider);
        });
      });

      observer.observe(slider, { attributes: true, attributeFilter: ['selected-index'] });
    });
  }

  function sectionPosition(section, sections) {
    var index = sections.indexOf(section);
    return index >= 0 ? index + 1 : null;
  }

  function trackSectionView(section, sections) {
    if (!section || !section.dataset) return;
    if (section.dataset.colamyAnalyticsSectionViewed === 'true') return;

    section.dataset.colamyAnalyticsSectionViewed = 'true';
    track('home_section_view', {
      section_id: section.id || '',
      section_type: getSectionType(section),
      section_handle: getSectionHandle(section),
      position: sectionPosition(section, sections),
    });
  }

  function observeSectionViews(main) {
    var sectionNodes = main && typeof main.querySelectorAll === 'function'
      ? main.querySelectorAll(SECTION_SELECTOR)
      : document.querySelectorAll && document.querySelectorAll(SECTION_SELECTOR);
    var sections = Array.prototype.slice.call(sectionNodes || []);
    if (!sections.length) return;

    var IntersectionObserverConstructor = window.IntersectionObserver || window.WebKitIntersectionObserver;
    if (typeof IntersectionObserverConstructor !== 'function') {
      sections.forEach(function (section) {
        trackSectionView(section, sections);
      });
      return;
    }

    var observer = new IntersectionObserverConstructor(function (entries) {
      entries.forEach(function (entry) {
        var visible = entry.isIntersecting || entry.intersectionRatio >= SECTION_VIEW_THRESHOLD;
        if (!visible) return;

        trackSectionView(entry.target, sections);
        if (typeof observer.unobserve === 'function') {
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: SECTION_VIEW_THRESHOLD });

    sections.forEach(function (section) {
      if (section && section.dataset && section.dataset.colamyAnalyticsSectionObserved !== 'true') {
        section.dataset.colamyAnalyticsSectionObserved = 'true';
        observer.observe(section);
      }
    });
  }

  function init() {
    if (window.__colamyHomeAnalyticsInitialized) return;
    if (!isHomePage()) return;
    if (!analytics()) return;

    var main = document.querySelector && document.querySelector('#MainContent');
    if (!main || typeof main.addEventListener !== 'function') return;

    window.__colamyHomeAnalyticsInitialized = true;

    track('home_view');

    main.addEventListener('click', handleButtonClick);
    main.addEventListener('click', handleSliderControlClick);
    main.addEventListener('pointerdown', handlePointerDown);
    main.addEventListener('pointerup', handlePointerUp);
    observeSectionViews(main);
    observeSliderChanges();

    document.addEventListener('shopify:section:load', observeSliderChanges);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
